import React from 'react';
import Loadable from '@components/Loadable';
import { lazy } from 'react';
import ManageDepot from './ManageDepot';
import ManageFiles from './ManageFiles';
import DetailCustomer from './ManageCustomer/components/Detail/DetailCustomer';

const Customer = Loadable(lazy(() => import('../AdminPage/ManageCustomer')));
const CustomerTag = Loadable(lazy(() => import('../AdminPage/ManageCustomerTag')));
const UserOperator = Loadable(lazy(() => import('../AdminPage/ManageUserOperator')));
const TariffPlan = Loadable(lazy(() => import('../AdminPage/TariffPlan')));
const Role = Loadable(lazy(() => import('../AdminPage/ManageRole')));
const Transaction = Loadable(lazy(() => import('../AdminPage/ManageTransaction')));
const TrasactionDetail = Loadable(
  lazy(() => import('../AdminPage/ManageTransaction/components/Detail'))
);
const CarInfo = Loadable(lazy(() => import('../AdminPage/ManageCarInfo')));
const PartnerCustomer = Loadable(lazy(() => import('../AdminPage/ManagePartnerCustomer')));
const ManageVoucher = Loadable(lazy(() => import('../AdminPage/ManageVoucher')));
const ManagePartner = Loadable(lazy(() => import('../AdminPage/ManagePartner')));
const ManagePartnerTariff = Loadable(lazy(() => import('../AdminPage/ManagePartnerTariff')));
const ManagePartnerCustomerGroup = Loadable(
  lazy(() => import('../AdminPage/ManagePartnerCustomerGroup'))
);
const ManageCustomerGroupAdmin = Loadable(
  lazy(() => import('../AdminPage/ManageCustomerGroupAdmin'))
);
const ManagePartnerRfid = Loadable(lazy(() => import('../AdminPage/ManagePartnerRfid')));
const ManagePartnerVoucher = Loadable(lazy(() => import('../AdminPage/ManagePartnerVoucher')));
const ManageWithdrawal = Loadable(lazy(() => import('../AdminPage/ManageWithdrawal')));
const ManageDepotFeeProfile = Loadable(lazy(() => import('../AdminPage/ManageDepotFeeProfile')));
const ManagePricingClaim = Loadable(lazy(() => import('../AdminPage/ManagePricingClaim')));
const adminRouters = [
  {
    path: '/admin/customer',
    element: <Customer />
  },
  {
    path: '/admin/customer/:id',
    element: <DetailCustomer />
  },
  {
    path: '/admin/tag',
    element: <CustomerTag />
  },
  {
    path: '/admin/carInfo',
    element: <CarInfo />
  },
  {
    path: '/admin/user',
    element: <UserOperator />
  },
  {
    path: '/admin/role',
    element: <Role />
  },
  {
    path: 'admin/charging-session',
    element: <Transaction />
  },
  {
    path: 'admin/charging-session/:id/detail',
    element: <TrasactionDetail />
  },
  {
    path: '/admin/tariff',
    element: <TariffPlan />
  },
  {
    path: '/admin/depots',
    element: <ManageDepot />
  },
  {
    path: '/admin/files',
    element: <ManageFiles />
  },
  {
    path: '/admin/partner-customers',
    element: <PartnerCustomer />
  },
  {
    path: '/admin/vouchers',
    element: <ManageVoucher />
  },
  {
    path: '/admin/partners',
    element: <ManagePartner />
  },
  {
    path: '/admin/partner-tariffs',
    element: <ManagePartnerTariff />
  },
  {
    path: '/admin/partner-customer-groups',
    element: <ManagePartnerCustomerGroup />
  },
  {
    path: '/admin/customer-groups',
    element: <ManageCustomerGroupAdmin />
  },
  {
    path: '/admin/partner-rfids',
    element: <ManagePartnerRfid />
  },
  {
    path: '/admin/partner-vouchers',
    element: <ManagePartnerVoucher />
  },
  {
    path: '/admin/withdrawals',
    element: <ManageWithdrawal />
  },
  {
    path: '/admin/depot-fee-profiles',
    element: <ManageDepotFeeProfile />
  },
  {
    path: '/admin/pricing-claims',
    element: <ManagePricingClaim />
  }
];

export default adminRouters;
